<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="600px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-id-card-alt</v-icon>
              <span class="px-3">{{ $t("Edit Salesman's Information") }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout wrap>
            <v-flex pa-2 xs11 :class="{ xs12: !hasPermissions(['users_store']) }">
              <v-autocomplete
                v-model="salesmanInfo.user_id_fk"
                :items="staffsList"
                :label="`${$t('Staff')} *`"
                box
                hide-details
                :error="errors.has('Staff')"
                background-color="white"
                v-validate="'required'"
                data-vv-name="Staff"
                :menu-props="{ transition: 'slide-y-transition' }"
              />
            </v-flex>

            <v-flex xs1 pt-2 v-if="hasPermissions(['users_store'])">
              <v-tooltip top>
                <v-btn label @click="$emit('add-staff')" slot="activator" icon fab small color="green">
                  <v-icon color="white" size="25">add</v-icon>
                </v-btn>
                <span>{{ $t('Add new staff') }}</span>
              </v-tooltip>
            </v-flex>

            <v-flex xs8 pa-2 :class="{ xs12: salesmanInfo.commissionList === 'No Commission' }">
              <v-autocomplete
                v-model="salesmanInfo.commission_type"
                :items="commissionList"
                :label="`${$t('Commission Type')} *`"
                box
                hide-details
                browser-autocomplete
                background-color="white"
                data-vv-name="commission_type"
                :menu-props="{ transition: 'slide-y-transition' }"
                :error="errors.has('commission_type')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs4 class="pa-2">
              <v-text-field
                v-show="salesmanInfo.commission_type"
                v-if="salesmanInfo.commission_type !== 'No Commission'"
                v-model="salesmanInfo.sale_man_commission_percentage"
                :label="$t('Percentage')"
                name="sale_man_commission_percentage"
                box
                hide-details
                suffix="%"
                v-validate="'decimal|between:0,100'"
                :error="errors.has('sale_man_commission_percentage')"
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-show="salesmanInfo.commission_type"
                v-if="salesmanInfo.commission_type !== 'No Commission'"
                v-model="salesmanInfo.sale_man_quota_1"
                :label="$t('Quota 1')"
                name="sale_man_quota_1"
                box
                v-validate="'decimal'"
                hide-details
                :error="errors.has('sale_man_quota_1')"
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-show="salesmanInfo.commission_type"
                v-if="salesmanInfo.commission_type !== 'No Commission'"
                v-model="salesmanInfo.sale_man_commission_percentage_1"
                :label="$t('Percentage 1')"
                name="sale_man_commission_percentage_1"
                box
                hide-details
                suffix="%"
                :error="errors.has('sale_man_commission_percentage_1')"
                v-validate="'decimal|between:0,100'"
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-show="salesmanInfo.commission_type"
                v-if="salesmanInfo.commission_type !== 'No Commission'"
                v-model="salesmanInfo.sale_man_quota_2"
                :label="$t('Quota 2')"
                name="sale_man_quota_2"
                box
                v-validate="'decimal'"
                :error="errors.has('sale_man_quota_2')"
                hide-details
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-show="salesmanInfo.commission_type"
                v-if="salesmanInfo.commission_type !== 'No Commission'"
                v-model="salesmanInfo.sale_man_commission_percentage_2"
                :label="$t('Percentage 2')"
                name="sale_man_commission_percentage_2"
                box
                suffix="%"
                v-validate="'decimal|between:0,100'"
                :error="errors.has('sale_man_commission_percentage_2')"
                hide-details
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-show="salesmanInfo.commission_type"
                v-if="salesmanInfo.commission_type !== 'No Commission'"
                v-model="salesmanInfo.sale_man_quota_3"
                :label="$t('Quota 3')"
                name="sale_man_quota_3"
                box
                v-validate="'decimal'"
                :error="errors.has('sale_man_quota_3')"
                hide-details
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-show="salesmanInfo.commission_type"
                v-if="salesmanInfo.commission_type !== 'No Commission'"
                v-model="salesmanInfo.sale_man_commission_percentage_3"
                :label="$t('Percentage 3')"
                name="sale_man_commission_percentage_3"
                box
                suffix="%"
                v-validate="'decimal|between:0,100'"
                :error="errors.has('sale_man_commission_percentage_3')"
                hide-details
                background-color="white"
              />
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: false
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      salesmanInfo: 'salesmen/getSalesmanInfo',
      commissionList: 'salesmen/getCommissionList',
      staffsList: 'staff/getFullStaffsList'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateSalesmanInfo: 'salesmen/updateSalesmanInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true

          let formData = new FormData(event.target)
          formData.append('commission_type', this.salesmanInfo.commission_type || '')
          formData.append('user_id_fk', this.salesmanInfo.user_id_fk)

          // for (let pair of formData.entries()) {
          //   console.warn(`${pair[0]}: ${pair[1]}`)
          // }

          let payload = { id: this.salesmanInfo.sale_man_id, formData }

          this.updateSalesmanInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
